"use strict";

require("core-js/modules/es6.array.filter");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.some");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsHost = exports.useNotificationsContext = exports.NotificationsContext = void 0;

var react_1 = __importDefault(require("react"));

var Notifications_1 = require("./Notifications");

exports.NotificationsContext = react_1["default"].createContext(undefined);

function useNotificationsContext(require) {
  var context = react_1["default"].useContext(exports.NotificationsContext);

  if (!context && require) {
    throw new Error('NotificationsContext is required, yet not provided.');
  }

  return context;
}

exports.useNotificationsContext = useNotificationsContext;

function NotificationsHost(_ref) {
  var children = _ref.children;

  var _react_1$default$useS = react_1["default"].useState([]),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      notifications = _react_1$default$useS2[0],
      setNotifications = _react_1$default$useS2[1];

  return react_1["default"].createElement(exports.NotificationsContext.Provider, {
    value: {
      registerNotification: function registerNotification(id, children) {
        setNotifications(function (n) {
          var hasExisting = n.some(function (notif) {
            return notif.key === id;
          });
          return hasExisting ? n.map(function (notif) {
            return notif.key === id ? {
              key: id,
              children: children
            } : notif;
          }) : [{
            key: id,
            children: children
          }].concat(_toConsumableArray(n));
        });
      },
      removeNotification: function removeNotification(id) {
        setNotifications(function (n) {
          return n.filter(function (notif) {
            return notif.key !== id;
          });
        });
      }
    }
  }, react_1["default"].createElement(Notifications_1.Notifications, {
    notifications: notifications
  }), children);
}

exports.NotificationsHost = NotificationsHost;